<div class="main_content">
  <app-breadcrumb></app-breadcrumb>
  <!-- <app-breadcrumb title="UnitWise Dashboard" breadcrumb="Dashboard / UnitWise Dashboard">
  </app-breadcrumb> -->
  <br><br>
  <div #page_section class="page_main_sec">
    <!-- <div class="main-content-section mt-15"> -->
    <div class="row dashboard-type-row">
      <!-- <input type="Text" value="Per" id="DefView" style="display:none">
          <div class="col" [ngClass]="{s5: documentTabList.length==1}">
            <div class="urn_details_UnitDashboard">
              <span class="bd-1"><span>
                <span style="border: 0px;"><i class="fa fa-map-marker" style="color: red;" aria-hidden="true"></i></span>
                <b style="font-weight:500!important">You are in-</b> <span style="font-weight: bold; border: 0px;">{{selectedDisplay}}</span></span></span>
            </div>
          </div> -->
      <div class="col s2 urn_details_UnitDashboard">
        <div class="dropdown-field fields-fixed-height">
          <mat-form-field appearance="legacy" [style.width.%]="100">
            <mat-label for="month_default">
              Month
              <span class="required">*</span>
            </mat-label>
            <mat-select [(ngModel)]="monthDefault" (selectionChange)="changeDashboardData($event)" id="month_default">
              <mat-option [value]="option.MonthId" *ngFor="let option of monthDropdown">
                {{ option.MonthName }}
              </mat-option>
            </mat-select>

          </mat-form-field>
        </div>
      </div>
      <div class="col s2 urn_details_UnitDashboard" *ngIf="showSearchBy">
        <form [formGroup]="frm" *ngIf="frm">
          <ng-container *ngFor="let field of fields" [ngSwitch]="field.controlType">
            <div class="col s2" *ngSwitchCase="'TEXTBOX'">
              <mat-form-field [style.width.%]="100" appearance="legacy" class="fields-fixed-height">
                <mat-label for="{field.parentFieldConfigName}">
                  {{field.parentFieldConfigName}}
                </mat-label>
                <input matInput [formControlName]="field.dbColumnName" [id]="field.parentFieldConfigName" />
              </mat-form-field>
            </div>
            <div *ngSwitchCase="'DROPDOWN'" class="col s2 dropdown-field fields-fixed-height" [style.width.%]="100">
              <mat-form-field appearance="legacy" [style.width.%]="100">
                <mat-label for="{field.parentFieldConfigName}">
                  {{ field.parentFieldConfigName }}
                </mat-label>
                <mat-select [formControlName]="field.dbColumnName" (selectionChange)="changeFilterData($event)"
                  [id]="field.parentFieldConfigName">
                  <mat-option [value]='0'>Select All</mat-option>
                  <mat-option [value]="option.id" *ngFor="let option of field.options">
                    {{ option.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngSwitchCase="'MULTIDROPDOWN'" class="col s2 dropdown-field fields-fixed-height">
              <mat-form-field appearance="legacy" [style.width.%]="100">
                <mat-label for="{field.parentFieldConfigName}">
                  {{ field.parentFieldConfigName }}
                </mat-label>
                <mat-select [formControlName]="field.dbColumnName" multiple [id]="field.parentFieldConfigName">
                  <mat-option [value]="option.id" *ngFor="let option of field.options">
                    {{ option.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col s2" *ngSwitchCase="'DATE'">
              <mat-form-field [style.width.%]="100" class="fields-fixed-height">
                <mat-label for="{field.parentFieldConfigName}">
                  {{ field.parentFieldConfigName }}
                </mat-label>
                <input matInput readonly [formControlName]="field.dbColumnName" [matDatepicker]="picker"
                  [id]="field.parentFieldConfigName" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </ng-container>
        </form>
      </div>
      <div class="col s3">
        <div class="urn_details_UnitDashboard" style="height: 100%;">
          <img src="../../assets/img/total_count.png" alt="total">&nbsp;&nbsp;&nbsp;
          <span class="td-count" style="width:100%!important; margin-bottom: 10px;">
            <p style="font-size: 14px; margin-bottom: 5px;">Overall Count</p>
            <span id="totreccount" style="font-size: 15px;">{{totalCriticalCount}}</span>
          </span>
          <!-- <span class="td-count" style="width:100%!important; margin-bottom: 10px;">
                <p style="font-size: 14px; margin-bottom: 5px;">Critical Count</p> 
                <span id="totreccount" style="font-size: 15px;">{{totalCriticalCount}}</span>
              </span> -->
        </div>
      </div>

      <div class="col s3  dropdown-field fields-fixed-height" *ngIf="documentTabList.length>1">
        <!-- <ul class="tabs customTabList">
              <li class="tab" *ngFor="let doc of documentTabList;">
                <a [ngClass]="{'active': doc.documentTypeId == activeDocument}" (click)="getDocumentGraphs(doc)">
                  <img src={{doc.documentTypeImage}} title={{doc.documentTypeName}} />
                  {{doc.documentTypeName}}
                </a>
              </li>
            </ul> -->

        <mat-form-field appearance="legacy" [style.width.%]="100">
          <mat-label for="document_type_name">
            Document Type Name
            <span class="required">*</span>
          </mat-label>
          <mat-select [(ngModel)]="documentTypeName" (selectionChange)="getDocumentGraphs($event)"
            id="document_type_name">
            <mat-option [value]="option.DOCUMENT_TYPE_ID" *ngFor="let option of documentTabList">
              {{ option.documentTypeName }}
            </mat-option>
          </mat-select>

        </mat-form-field>
      </div>


    </div>
    <div class="row">
      <div *ngIf="!isAction">
        <app-workflow-status #activityStatusComponent [overallActivityList]="overallActivityList"
          [criticalActivityList]="criticalActivityList" [charttabledata]="charttabledata"
          (tableOpened)="getTabularData($event)"></app-workflow-status>
      </div>
      <div *ngIf="isAction">
        <div class="col s8">
          <app-workflow-status #activityStatusComponent [overallActivityList]="overallActivityList"
            [criticalActivityList]="criticalActivityList" [charttabledata]="charttabledata"
            (tableOpened)="getTabularData($event)"></app-workflow-status>
        </div>
        <div class="col s4 commonGrid geotableStyle">
          <div class="white-box geoGraphicTable" style="height:340px">
            <div class="card-heading">
              <span>{{ actionText }}</span>
            </div>
            <ngx-datatable *ngIf="actionTable.length>0" class="material custom_common_table" #actionTableData
              id="chartsGrid" [limit]="actionTable.length" [rows]="actionTable" [columnMode]="'force'"
              [headerHeight]="41" [footerHeight]="0" [scrollbarV]="true" [scrollbarH]="true" [rowHeight]="60"
              style="height: 244px;" (activate)="onActionRowClick($event)">

              <ngx-datatable-footer *ngIf="false">
                <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                  let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
                  <div style="padding-top: 0px;">
                    <div>
                      {{curPage==1?(rowCount == 0 ? rowCount : curPage):curPage*pageSize+1-pageSize}}
                      -
                      {{(curPage==1? (rowCount < pageSize ? rowCount : pageSize ) :(((curPage*pageSize) <
                        rowCount)?(curPage*pageSize):rowCount))}} of {{rowCount}}</div>
                    </div>

                    <div class="current_page_select">
                    </div>

                    <datatable-pager [pagerLeftArrowIcon]="'fa fa-angle-left'"
                      [pagerRightArrowIcon]="'fa fa-angle-right'" [pagerPreviousIcon]="'fa fa-backward'"
                      [pagerNextIcon]="'fa fa-forward'" [page]="curPage" [size]="pageSize" [count]="rowCount"
                      [hidden]="!((rowCount / pageSize) > 1)" (change)="actionTableData.onFooterPage($event)">
                    </datatable-pager>
                </ng-template>
              </ngx-datatable-footer>

              <ngx-datatable-column *ngFor="let col of actionTableColumns" name={{col}} [sortable]="false" prop={{col}}
                [frozenLeft]="commonService.freezeColumn(col)">
              </ngx-datatable-column>

              <ngx-datatable-column name="Status" [sortable]="true" prop="status" [width]="80">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <p *ngIf="row['status'] == 'DELAYED'">
                    <img src="../../assets/img/icons/delayed.png" alt="Delayed Idea" width="25" />
                  </p>
                  <p *ngIf="row['status'] == 'DUE-TODAY'">
                    <img src="../../assets/img/icons/dueToday.png" alt="Due Today" width="25" />
                  </p>
                  <p *ngIf="row['status'] == 'DELAYED CLOSED'">
                    <img src="../../assets/img/icons/delayed-closed.png" alt="Delayed Closed Idea" width="25" />
                  </p>
                  <p *ngIf="row['status'] == 'DONE'">
                    <img src="../../assets/img/icons/closed.png" alt="Closed Idea" width="25" />
                  </p>
                  <p *ngIf="row['status'] == 'PENDING'">
                    <img src="../../assets/img/icons/pending.png" alt="Pending Idea" width="25" />
                  </p>
                </ng-template>
              </ngx-datatable-column>

            </ngx-datatable>
            <div *ngIf="actionTableMore" (click)="onActionRowClick($event)">
              <p *ngIf="actionTable.length!=0"> Click for more Idea.</p>
            </div>
            <!-- C:\Suresh-Projects\FAR\Angular_Application\FAR_Application\R2R_Platform_FAR\Release1\R2R-Platform-FAR-Web\src\assets\img\Smiley.jpg -->
            <!-- <div *ngIf="actionTable.length==0" style="text-align: center;" class="text-center"> -->
            <div *ngIf="actionTable.length==0" style="padding-left:25px"><br /><br /><br /><span>
                <img src="../../assets/img\Smiley.jpg" width="40px" height="40px" alt="Logo">
                It's good to not be overloaded all the time!</span>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="" *ngIf="isActivityStatusTableOpen">
      <div class="status-box-accordion-wrap">
        <div class="status-tab-wrap" id="completed-tab">
          <div class="tab-close-div" (click)="closeWorkflowStatusTable()">
            <img src="../../assets/img/cancel-icon.svg" alt="Cancel" class="close_tab_icon">
          </div>
          <h5>{{tableTitle}} Idea</h5>

          <div class="tableWrapper commonGrid geotableStyle">

            <div class="table_header_panel">
              <div class="search_area">
                <app-debounced-search-field (SearchClicked)="updateFilter($event)"></app-debounced-search-field>
                <i class="fa fa-search"></i>
              </div>
              <div class="download_btns">
                <button (click)="downloadExcel()" title="Download as Excel" class="waves waves-effect right">
                  <i class="fa fa-file-excel-o" color="black"></i>
                </button>
              </div>
            </div>

            <div class="tableDiv geoGraphicTable">
              <ngx-datatable class="material custom_common_table" #chartTable id="chartsGrid" [limit]=5
                [rows]="tableRows" [columnMode]="'force'" [headerHeight]="41" [footerHeight]="35" [scrollbarV]="true"
                [scrollbarH]="true" [rowHeight]="60" style="max-height: 300px;">

                <ngx-datatable-footer *ngIf="true">
                  <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                    let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
                    <div style="padding-top: 0px;">
                      <div>
                        {{curPage==1?(rowCount == 0 ? rowCount : curPage):curPage*pageSize+1-pageSize}}
                        -
                        {{(curPage==1? (rowCount < pageSize ? rowCount : pageSize ) :(((curPage*pageSize) <
                          rowCount)?(curPage*pageSize):rowCount))}} of {{rowCount}}</div>
                      </div>

                      <div class="current_page_select">
                      </div>

                      <datatable-pager [pagerLeftArrowIcon]="'fa fa-angle-left'"
                        [pagerRightArrowIcon]="'fa fa-angle-right'" [pagerPreviousIcon]="'fa fa-backward'"
                        [pagerNextIcon]="'fa fa-forward'" [page]="curPage" [size]="pageSize" [count]="rowCount"
                        [hidden]="!((rowCount / pageSize) > 1)" (change)="chartTable.onFooterPage($event)">
                      </datatable-pager>
                  </ng-template>
                </ngx-datatable-footer>

                <ngx-datatable-column name="Sr.No." [sortable]="true" prop="Sr.No." [width]="45" [frozenLeft]="true">
                  <ng-template let-row="row" let-rowIndex="index" let-value="value" ngx-datatable-cell-template>
                    <p>{{getRowIndex(row)}}</p>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="URN" [sortable]="true" prop="urn" [width]="215" [frozenLeft]="true">
                  <ng-template let-row="row" let-rowIndex="index" let-value="value" ngx-datatable-cell-template>
                    <p title="{{row.urn}}">{{row["urn"]}}</p>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column *ngFor="let col of tableColumns" name={{getColumnParameters(col)}}
                  [sortable]="false" prop={{col}} [width]="getColumnParameters(col, 'width')"
                  [frozenLeft]="commonService.freezeColumn(col)">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <p *ngIf="!commonService.isNumeric(row[col])">{{ row[col] }}</p>
                    <p *ngIf="commonService.isNumeric(row[col])" style="text-align: right;">{{ row[col] | number :
                      '1.2-2' }}</p>
                  </ng-template>
                </ngx-datatable-column>

              </ngx-datatable>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="">
      <div class="dashboard-charts-slider-wrap">

        <div class="dashboard-charts-slider">
          <div class="row carousel">
            <!-- col-lg-4 -->
            <!-- <div class="dashboard-charts-row carousel-item"> -->

            <div class="col-lg-6 m4 l4">
              <div class="chart-box">
                <h4>
                  <img src="../../assets/img/graph_heading_icon.png" alt="Progress Status">
                  Progress Status %
                  <span style="float: right;" (click)="exportChart('overallCompletedChart')">
                    <i class="fa fa-download"></i>
                  </span>
                </h4>
                <div id="overallCompletedChart"></div>
              </div>

            </div>
            <!-- <div class="col-lg-4 m4 l4">
                    <div class="chart-box commonGrid geotableStyle">
                      <h4>
                        <img src="../../assets/img/graph_heading_icon.png">
                        SLA wise Idea 
                        <span *ngIf="!isSlaChartTableOpen"
                          style="float: right;" 
                          (click)="exportChart('sla-pie-chart')">
                          <i class="fa fa-download"></i>
                        </span>
                        <a *ngIf="isSlaChartTableOpen" (click)="closeSlaChartTable()" class="btn chart-btn button float-right sla-chart-btn btn-primary btn-small">back</a>
                      </h4>
                      <div [style.display]="!isSlaChartTableOpen?'block':'none'" id="sla-pie-chart"></div>
                      <div *ngIf="isSlaChartTableOpen" id="sla-activites-table" class="chart-tables geoGraphicTable">
                        
                        <ngx-datatable 
                          class="material custom_common_table" 
                          #slaTable id="chartsGrid" [limit]="slaTableData.length"
                          [rows]="slaTableData" [columnMode]="'force'" 
                          [headerHeight]="41" [footerHeight]="35"
                          [scrollbarV]="true" [scrollbarH]="true" 
                          [rowHeight]="60" style="max-height: 300px;">

                          <ngx-datatable-footer *ngIf="true">
                            <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                                let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
                                <div style="padding-top: 0px;">
                                  <div>
                                    {{curPage==1?(rowCount == 0 ? rowCount : curPage):curPage*pageSize+1-pageSize}}
                                    -
                                    {{(curPage==1? (rowCount < pageSize ? rowCount : pageSize )
                                        :(((curPage*pageSize) < rowCount)?(curPage*pageSize):rowCount))}} of
                                        {{rowCount}}</div>
                                  </div>

                                  <div class="current_page_select">
                                  </div>

                                <datatable-pager [pagerLeftArrowIcon]="'fa fa-angle-left'"
                                  [pagerRightArrowIcon]="'fa fa-angle-right'"
                                  [pagerPreviousIcon]="'fa fa-backward'" [pagerNextIcon]="'fa fa-forward'"
                                  [page]="curPage" [size]="pageSize" [count]="rowCount"
                                  [hidden]="!((rowCount / pageSize) > 1)"
                                  (change)="slaTable.onFooterPage($event)">
                                </datatable-pager>
                            </ng-template>
                          </ngx-datatable-footer>

                          <ngx-datatable-column 
                            *ngFor="let col of slaTableColumns" 
                            name={{col}} 
                            [sortable]="false" 
                            prop={{col}}
                            [frozenLeft]="commonService.freezeColumn(col)">
                          </ngx-datatable-column>
                        
                        </ngx-datatable>
                        
                      </div>
                    </div>

                  </div> -->
            <div class="col-lg-6 m4 l4">
              <div class="chart-box commonGrid geotableStyle">
                <h4>
                  <img src="../../assets/img/graph_heading_icon.png" alt="Progress Status">
                  Critical Idea
                  <span *ngIf="!isCriticalTableOpen" style="float: right;" (click)="exportChart('critical-pie-chart')">
                    <i class="fa fa-download"></i>
                  </span>
                  <a *ngIf="isCriticalTableOpen" (click)="closeCriticalTable()"
                    class="btn chart-btn button float-right critical-chart-btn btn-primary btn-small">back</a>
                </h4>

                <div [style.display]="!isCriticalTableOpen?'block':'none'" id="critical-pie-chart"></div>
                <div *ngIf="isCriticalTableOpen" id="critical-activites-table" class="chart-tables geoGraphicTable">
                  <ngx-datatable class="material custom_common_table" #criticalTable id="chartsGrid"
                    [limit]="criticalTableData.length" [rows]="criticalTableData" [columnMode]="'force'"
                    [headerHeight]="41" [footerHeight]="35" [scrollbarV]="true" [scrollbarH]="true" [rowHeight]="60"
                    style="max-height: 300px;">

                    <ngx-datatable-footer *ngIf="true">
                      <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                        let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
                        <div style="padding-top: 0px;">
                          <div>
                            {{curPage==1?(rowCount == 0 ? rowCount : curPage):curPage*pageSize+1-pageSize}}
                            -
                            {{(curPage==1? (rowCount < pageSize ? rowCount : pageSize ) :(((curPage*pageSize) <
                              rowCount)?(curPage*pageSize):rowCount))}} of {{rowCount}}</div>
                          </div>

                          <div class="current_page_select">
                          </div>

                          <datatable-pager [pagerLeftArrowIcon]="'fa fa-angle-left'"
                            [pagerRightArrowIcon]="'fa fa-angle-right'" [pagerPreviousIcon]="'fa fa-backward'"
                            [pagerNextIcon]="'fa fa-forward'" [page]="curPage" [size]="pageSize" [count]="rowCount"
                            [hidden]="!((rowCount / pageSize) > 1)" (change)="criticalTable.onFooterPage($event)">
                          </datatable-pager>
                      </ng-template>
                    </ngx-datatable-footer>

                    <ngx-datatable-column *ngFor="let col of criticalTableColumns" name={{col}} [sortable]="false"
                      prop={{col}} [frozenLeft]="commonService.freezeColumn(col)">
                    </ngx-datatable-column>

                  </ngx-datatable>
                </div>
              </div>

            </div>
            <!-- </div> -->

            <!-- <div class="dashboard-charts-row carousel-item"> -->

            <!-- <div class="col-lg-4 m4 l4">
                    <div class="chart-box">
                      <h4>
                        <img src="../../assets/img/graph_heading_icon.png">
                        Idea Growth(MoM)
                        <span style="float: right;" 
                          (click)="exportChart('activity-growth-line-chart')">
                          <i class="fa fa-download"></i>
                        </span> 
                      </h4>
                      <div id="activity-growth-line-chart"></div>
                    </div>
                  </div> -->

            <!-- <div class="col-lg-4 m4 l4">
                    <div class="chart-box">
                      <h4>
                        <img src="../../assets/img/graph_heading_icon.png">
                        Idea Closure (MoM)
                        
                        <span style="float: right;" 
                          (click)="exportChart('activity-closure-line-chart')">
                          <i class="fa fa-download"></i>
                        </span>   
                      </h4>
                      <div id="activity-closure-line-chart"></div>
                    </div>
                  </div> -->

            <!-- <div class="col-lg-4 m4 l4">
                    <div class="chart-box">
                      <h4>
                        <img src="../../assets/img/graph_heading_icon.png"> 
                        {{Compliance_Title}}
                        
                        <span style="float: right;" 
                          (click)="exportChart('overall-performance-line-chart')">
                          <i class="fa fa-download"></i>
                        </span>  
                      </h4>
                      <div id="overall-performance-line-chart"></div>
                    </div>

                  </div> -->
            <!-- </div> -->

          </div>

          <!-- <a class="float-button" (click)="nextPrevMonth('next')">
                <i class="fa fa-caret-right"></i>
              </a>
              <a class="float-button-left" (click)="nextPrevMonth('prev')">
                <i class="fa fa-caret-left"></i>
              </a> -->

          <div class="row">
            <div class="dashboard-charts-row">
              <div class="col m6 l4">
                <div class="chart-box commonGrid geotableStyle">
                  <h4>
                    <img src="../../assets/img/graph_heading_icon.png" alt="Progress Status">
                    Completed Idea

                    <span *ngIf="!isCompletedTableOpen" style="float: right;"
                      (click)="exportChart('completed-pie-chart')">
                      <i class="fa fa-download"></i>
                    </span>

                    <a *ngIf="isCompletedTableOpen" (click)="closeCompletedTable()"
                      class="btn chart-btn button float-right delayed-chart-btn btn-primary btn-small">back</a>
                  </h4>

                  <div [style.display]="!isCompletedTableOpen?'block':'none'" id="completed-pie-chart"></div>
                  <div *ngIf="isCompletedTableOpen" id="completed-activites-table" class="chart-tables geoGraphicTable">
                    <ngx-datatable class="material custom_common_table" #completedTable id="chartsGrid"
                      [limit]="completedTableData.length" [rows]="completedTableData" [columnMode]="'force'"
                      [headerHeight]="41" [footerHeight]="35" [scrollbarV]="true" [scrollbarH]="true" [rowHeight]="60"
                      style="max-height: 300px;">

                      <ngx-datatable-footer *ngIf="true">
                        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                          let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
                          <div style="padding-top: 0px;">
                            <div>
                              {{curPage==1?(rowCount == 0 ? rowCount :
                              curPage):curPage*pageSize+1-pageSize}}
                              -
                              {{(curPage==1? (rowCount < pageSize ? rowCount : pageSize ) :(((curPage*pageSize) <
                                rowCount)?(curPage*pageSize):rowCount))}} of {{rowCount}}</div>
                            </div>

                            <div class="current_page_select">

                            </div>

                            <datatable-pager [pagerLeftArrowIcon]="'fa fa-angle-left'"
                              [pagerRightArrowIcon]="'fa fa-angle-right'" [pagerPreviousIcon]="'fa fa-backward'"
                              [pagerNextIcon]="'fa fa-forward'" [page]="curPage" [size]="pageSize" [count]="rowCount"
                              [hidden]="!((rowCount / pageSize) > 1)" (change)="completedTable.onFooterPage($event)">
                            </datatable-pager>
                        </ng-template>
                      </ngx-datatable-footer>

                      <ngx-datatable-column *ngFor="let col of completedTableColumns" name={{col}} [sortable]="false"
                        prop={{col}} [frozenLeft]="commonService.freezeColumn(col)">
                      </ngx-datatable-column>

                    </ngx-datatable>
                  </div>
                </div>

              </div>

              <div class="col m6 l8">
                <div class="chart-box">
                  <h4>
                    <img src="../../assets/img/graph_heading_icon.png" alt="Progress Status">
                    5 Days Summary

                    <span style="float: right;" (click)="exportChart('day-summary-chart')">
                      <i class="fa fa-download"></i>
                    </span>
                  </h4>
                  <div id="day-summary-chart"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</div>